import { request } from '@h3/request';
/** 根据指定报表编码获取报表下所有图表 */
export function getWidgetByDashboardId(dashboardId) {
    return request('/v1/chartnode/bydashboard', {
        method: 'get',
        params: {
            dashboardId,
        },
    });
}
